import $ from 'jquery';
import {gsap} from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { isMobile } from 'detect-touch-device';
import CustomAnimations from "src/scripts/modules/CustomAnimations";
import Home from "src/scripts/pages/home";
import Work from "src/scripts/pages/work";

let pageName = jQuery('body').data('page');
let home = new Home();
let work = new Work();
const animations = new CustomAnimations();
let smoother;

function openNavigation() {

  // block scroller
  if(!isMobile) {
    smoother = animations.getSmoother();
    smoother.paused(true);
  }


  $(".burger_menu").addClass("burger_menu_close");
  $(".burger_label").addClass("navi_is_open");
  $('.top_logo').addClass('navi_is_open');

  home.hidePage();

  var tl = gsap.timeline({});
  tl.set('#mainNav', {
    rotate: -4,
    top: '130%',
    scale: 1.3,
    duration:0}, 0);
  tl.to('#mainNav', {
    rotate: 0,
    duration: .8,
    ease: "expo.out",
    repeat: 0,
    scale: 1,
    top: '0%'}, 0);
  tl.to('#mainNav', {
    rotate: 0,
    duration: 0,
    ease: "expo.out",
    repeat: 0,
    scale: 1,
    top: '0%'}, 1);

  // nav items
  $('.nav-item-main').each(function( i ) {
    let delay = $(this).data('delay');
    let splitNavItem = new SplitText( $(this), {type: "lines", linesClass: "split-line"});

    gsap.set(splitNavItem.lines, {
      top: '150px',
      autoAlpha: 0
    });
    gsap.to(splitNavItem.lines, {
      duration: .8,
      ease: "power3.out",
      top: 0,
      delay: .2 + (i*.1) + delay,
      autoAlpha: 1,
      stagger: 0.05
    });
  });

  // navi spacer
  gsap.set('.nav_spacer', {
    width: 0,
    duration: 0
  });
  gsap.to('.nav_spacer', {
    duration: 1,
    width: '100%',
    ease: "power4.out",
    delay: 1.3
  });
}
function closeNavigation() {

  // block scroller
  if(!isMobile) {
    smoother = animations.getSmoother();
    smoother.paused(false);
  }

  setTimeout(function () {
  }, 90);
  $(".burger_menu").removeClass("burger_menu_close");
  $(".burger_label").removeClass("navi_is_open");
  $('.top_logo').removeClass('navi_is_open');

  home.showPage();

  var tl = gsap.timeline({});
  tl.set('#mainNav', {
    rotate: 0,
    duration: 0,
    repeat: 0,
    scale: 1,
    top: '0%'}, 0);
  tl.to('#mainNav', {
    duration: 1,
    ease: "expo.out",
    rotate: -4,
    top: '130%',
    scale: 1.3,
    overwrite: true}, 0);

  gsap.to('.nav_spacer', {
    duration: .2,
    width: 0,
    overwrite: true
  });
}

function showPageCloser(url) {
  work.hidePage(1);

  setTimeout(function () {
    scrollTop();
  }, 500);

  var tl1 = gsap.timeline({});
  tl1.set('.pagecloser_logo', {
    alpha:0,
    rotate: -15,
    duration: 0,
    scale: .5}, 0);
  tl1.to('.pagecloser_logo', {
    alpha:1,
    rotate: 0,
    duration: 1,
    scale: 1,
    delay: 0}, 0);

  // main menu layer
  var tl2 = gsap.timeline({onComplete: showNewPage, onCompleteParams: [url] });
  tl2.set('.pagecloser', {
    rotate: -4,
    top: '130%',
    scale: 1.3,
    duration:0}, 0);
  tl2.to('.pagecloser', {
    rotate: -4,
    duration: 1,
    ease: "expo.out",
    repeat: 0,
    scale: 1.3,
    top: '0%'}, 0);
  tl2.to('.pagecloser', {
    rotate: 0,
    duration: .5,
    ease: "expo.out",
    repeat: 0,
    scale: 1,
    top: '0%'}, .8);
}
function showNewPage(url) {

  if(process.env.NODE_ENV === 'production' && pageName === 'work') {
    var newUrl = url.replace(".html","")
    url = newUrl;
  }

  window.location.href = url
}

function scrollTop() {
  smoother = animations.getSmoother();

  if (!isMobile) {
    gsap.to(smoother, {
      scrollTop: -1,
      duration: 0.1,
      ease: "power4.out",
    });
  }
  else {
    gsap.to(window, {
      duration: 0,
      ease: "power4.out",
      scrollTo:{
        y: -1,
        autoKill: false}
    })
  }
}

class ModuleNavigation {
  init() {
    this.initPage();
    this.initListener();
  }

  initPage = () => {
    gsap.registerPlugin(ScrollTrigger, SplitText, ScrollToPlugin );

    //openNavigation();

    if(pageName === 'work') { $('.top_nav .btn').addClass('btn_black'); }
  }

  initListener = () => {

    $( '.top-nav-link, .top_logo, .btn-scroll' ).on( 'click', function( event )
    {
      event.preventDefault();

      closeNavigation();

      if(pageName === 'home') {

        if(!isMobile) {
          smoother = animations.getSmoother();
          smoother.scrollTo( $(this).attr('href'), true );
        }
        else {

          //alert($(this).data('anchor'));

          gsap.to(window, {
            duration: 2,
            ease: "power4.out",
            scrollTo:{
              y: $(this).attr('href'),
              //autoKill: false
            }
          })
        }
      }
      else {
        let url = $(this).data('anchor');
        showPageCloser(url);
      }
    });

    $( '.main-nav-link' ).on( 'click', function( event )
    {
      // if imprint
      if(!$(this).hasClass('small')) {
        event.preventDefault();
      }
      else {
        return;
      }

      if(pageName === 'home') {

        home.showPage(0);

        if(!isMobile) {
          smoother = animations.getSmoother();
          smoother.scrollTo( $(this).attr('href') );
        }
        else {
          gsap.to(window, {
            duration: 0,
            scrollTo: $(this).attr('href'),
            ease: "Power1.easeInOut"
          });
        }

        home.hidePage(0);

        setTimeout(function () {
          closeNavigation();
        }, 100);
      }
      else {
        let url = $(this).data('anchor');
        showPageCloser(url);
        //window.location.href = $(this).data('anchor');
      }
    });

    $(".burger_menu").click(function(e)
    {
      e.preventDefault()
      if (!$(this).hasClass("burger_menu_close"))
      {
        openNavigation();
      }
      else
      {
        closeNavigation(true);
      }
    });
  }
}

export default ModuleNavigation;
